const fontWeight = {
    bold: 700,
    medium: 500,
    regular: 400,
}

export default fontWeight
export type FontWeight = typeof fontWeight
